import * as v from 'valibot';

import { EMaoLegType } from '#shared';

import { maoAirportSchema } from './maoAirport.schema';
import { maoMovementSchema } from './maoMovement.schema';

import type { MaoTripLeg } from '../types';

export const maoTripLegSchema: v.GenericSchema<MaoTripLeg> = v.object({
  Id: v.number('Trip leg ID is missing'),
  TripId: v.number('Trip ID is missing'),
  OffBlocksUtc: v.string('Off blocks UTC is missing'),
  OffBlocksUtcUnix: v.number('Off blocks UTC unix is missing'),
  OnBlocksUtc: v.string('On blocks UTC is missing'),
  OnBlocksUtcUnix: v.number('On blocks UTC unix is missing'),
  LegType: v.enum(
    EMaoLegType,
    issue => `@WARNING: Unexpected leg type ${issue.input}`,
  ),
  Movement: v.optional(maoMovementSchema),
  DepartureAirport: maoAirportSchema,
  ArrivalAirport: maoAirportSchema,
  SectorIndex: v.number('Sector index is missing'),
});
